
import React from 'react';
import PropTypes from 'prop-types';

const HomeIconFilled = ({ className }) => {
  return (
    <svg 
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      className={`fill-current ${className}`}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M20.9359 9.63399C20.9354 9.63351 20.9349 9.63303 20.9345 9.63255L12.3672 1.06653C12.0021 0.701233 11.5166 0.5 11.0001 0.5C10.4837 0.5 9.99819 0.701073 9.63286 1.06637L1.07013 9.62806C1.06725 9.63094 1.06436 9.63399 1.06148 9.63687C0.311587 10.391 0.312869 11.6146 1.06517 12.3668C1.40887 12.7106 1.86281 12.9098 2.34816 12.9306C2.36786 12.9325 2.38773 12.9335 2.40776 12.9335H2.74922V19.2376C2.74922 20.485 3.7643 21.5 5.0122 21.5H8.36397C8.70366 21.5 8.97926 21.2246 8.97926 20.8848V15.9424C8.97926 15.3731 9.44234 14.9101 10.0117 14.9101H11.9886C12.5579 14.9101 13.021 15.3731 13.021 15.9424V20.8848C13.021 21.2246 13.2964 21.5 13.6363 21.5H16.9881C18.236 21.5 19.251 20.485 19.251 19.2376V12.9335H19.5677C20.0839 12.9335 20.5694 12.7324 20.9349 12.3671C21.688 11.6136 21.6884 10.388 20.9359 9.63399Z" fill="currentColor"/>
    </svg>
  );
};

HomeIconFilled.propTypes = {
  className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

HomeIconFilled.defaultProps = {
  className: '', // Default to an empty string
};

export default HomeIconFilled;